import React from "react";
import { useEffect } from "react";
import "../styles/main.css";
import "../styles/slidersCardStyles.css";
import "../styles/slick.css";
import MainCarousel from "../Components/carousel/MainCarousel";
import SpecialFooterBar from "../Components/common/SubFooterBar";
import WelcomeContent from "../Components/contents/WelcomeContent";
import GoToTreatmentsContent from "../Components/contents/GoToTreatmentsContent";
import MainTreatmentCategorySlider from "../Components/slider/CategoriesSlider";
import PackagesSlider from "../Components/slider/PackagesSlider";
import TestimonialSlider from "../Components/slider/TestimonialSlider";
import HomeAboutUsContent from "../Components/contents/HomeAboutUsContent";
import WorkSchedulesContent from "../Components/contents/WorkSchedulesContent";
import OurCompaniesSlider from "../Components/slider/OurCompaniesSlider";
import AchievementsContent from "../Components/contents/AchievementsContent";

const HomePage = () => {
  return (
    <>
      <MainCarousel />
      <div className="px-7">
        <WelcomeContent />
        <WorkSchedulesContent />
        <MainTreatmentCategorySlider />
        <GoToTreatmentsContent />
        <PackagesSlider />
      </div>
      <HomeAboutUsContent />
      <div className="px-7">
        <OurCompaniesSlider />

        <AchievementsContent />
      </div>
      <TestimonialSlider />
      <SpecialFooterBar />

    </>
  );
};

export default HomePage;
